import React from "react";
import { useTranslation } from "react-i18next";
import { ShareIcon, AddToHomeIcon } from "./InstallIcons";

// Safari installation instructions component
const SafariInstructions: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div>
      <p className="mb-2 font-semibold text-foreground">
        {t("installAppIOS.safari.title")}
      </p>
      <div className="mb-2 flex items-center gap-3">
        <div className="shrink-0">
          <ShareIcon className="size-5" />
        </div>
        <p className="text-sm text-foreground">
          {t("installAppIOS.safari.step1")}
        </p>
      </div>
      <div className="flex items-center gap-3">
        <div className="shrink-0">
          <AddToHomeIcon className="size-5" />
        </div>
        <p className="text-sm text-foreground">
          {t("installAppIOS.safari.step2")}
        </p>
      </div>
    </div>
  );
};

export default SafariInstructions;
